import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import "typeface-roboto";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AppContext from "./AppContext";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.render(
  <AppContext>
    <App />
  </AppContext>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
